import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

// This guard checks if the required parameters are present and valid.
// If not, it redirects to the error page.
export const validParamsGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const requiredParams = route.data['requiredParams'] as string[];
  if (requiredParams) {
    for (const param of requiredParams) {
      if (!route.paramMap.has(param) || !isValidParam(route.paramMap.get(param))) {
        router.navigate(['/error']);
        return false;
      }
    }
  }

  return true;
};

const isValidParam = (param: string | null): boolean => {
  return param !== null && param.trim() !== '';
};
